import { useCallback } from "react";
import { useMutation } from "@apollo/react-hooks";
import { MY_DOCUMENTS_USERS } from "my-documents/graphql/mutations";

interface RoleFilters {
  [key: string]: any; // Replace 'any' with specific types if known
}

export const useMyDocumentsUsers = ({
  roleFilters,
  tableData,
  onCompleted,
  role,
  filterable = true,
}: {
  roleFilters: RoleFilters;
  tableData: {
    sortField?: string;
    sortDirection?: string;
    page?: number;
    pageSize?: number;
    searchField?: string;
    searchText?: string;
  };
  onCompleted: (result: any[]) => void; // Replace 'any' with specific types if known
  role: string;
  filterable?: boolean;
}) => {
  delete roleFilters.__typename;

  let queryParams: {
    roleFilters: RoleFilters;
    sortField?: string;
    sortDirection?: string;
    role: string;
    page?: number;
    pageSize?: number;
    searchField?: string;
    searchText?: string;
  } = {
    roleFilters: roleFilters,
    sortField: tableData?.sortField,
    sortDirection: tableData?.sortDirection,
    role,
    page: tableData?.page,
    pageSize: tableData?.pageSize,
  };

  if (tableData?.searchField && tableData?.searchText) {
    queryParams.searchField = tableData?.searchField;
    queryParams.searchText = tableData?.searchText;
  }

  const [loadQueryMutation, { data, loading, error }] = useMutation(
    MY_DOCUMENTS_USERS,
    {
      variables: queryParams,
    },
  );

  const loadQuery = useCallback(async () => {
    const mutationResult = await loadQueryMutation();
    let result = mutationResult.data?.usersToMyDocumentsPages;
    onCompleted(result ? result : []);
    return mutationResult;
  }, [loadQueryMutation, onCompleted]);

  let result = data?.usersToMyDocumentsPages;

  return {
    data: result ? result : [],
    loading,
    error,
    loadQuery,
    filterable,
  };
};

export default useMyDocumentsUsers;
